import { Box, CircularProgress } from '@mui/material'
import { assertEx } from '@xylabs/sdk-js'
import { useNavigateToEthAddress } from '@xylabs/sdk-react'
import { useContext } from 'react'

import { EntityContext } from '../../../../Contexts'
import LargeUp from './LargeUp'

interface Props {
  page?: string
  to?: string
}

const Summary: React.FC<Props> = (props) => {
  const { to, page = 'auction' } = props
  const entity = useContext(EntityContext)
  const { navigateToEthAddress } = useNavigateToEthAddress()

  const onClick = (event: React.MouseEvent) => {
    navigateToEthAddress(assertEx(entity?.address), event, page, to)
  }

  if (entity) {
    return (
      <Box display="flex" flexDirection="row" onClick={onClick} style={{ cursor: 'pointer' }}>
        <LargeUp />
      </Box>
    )
  }
  return (
    <Box alignItems="center" display="flex" justifyContent="center" minHeight={56} width="100%">
      <CircularProgress size={24} />
    </Box>
  )
}

export default Summary
